import ILocationSearchType from '../interfaces/ilocation-search-type';
import ILocation from '../interfaces/ilocation';

export default {
    // VM
    setHasError: (state: any, newValue: boolean) => state.HasError = newValue,
    setIsLoading: (state: any, newValue: boolean) => state.IsLoading = newValue,
    setLocationSearchTypes: (state: any, newValue: ILocationSearchType[]) => state.LocationSearchTypes = newValue,
    setLocations: (state: any, newValue: ILocation[]) => state.Locations = newValue,
    setSelectedLocation: (state: any, newValue: ILocation) => state.SelectedLocation = newValue,
    setSelectedIndex: (state: any, newValue: number) => state.SelectedIndex = newValue,
    setFocusedIndex: (state: any, newValue: number) => state.FocusedIndex = newValue,
    // Maps
    setShowMyLocation: (state: any, newValue: boolean) => state.ShowMyLocation = newValue,
    setGMap: (state: any, newValue: google.maps.Map) => state.GMap = newValue,
    setAutoComplete: (state: any, newValue: google.maps.places.Autocomplete) => state.AutoComplete = newValue,
    setLocationMarkers: (state: any, newValue: google.maps.Marker[]) => state.LocationMarkers = newValue,
    setLocationMarker: (state: any, newValue: google.maps.Marker[], index: number) => state.LocationMarkers[index] = newValue,
    setCurrentLocationMarker: (state: any, newValue: google.maps.Marker) => state.CurrentLocationMarker = newValue,
    setCurrentUserLatitude: (state: any, newValue: number) => state.CurrentUserLatitude = newValue,
    setCurrentUserLongitude: (state: any, newValue: number) => state.CurrentUserLongitude = newValue,
    setCurrentUserCoords: (state: any, newValue: GeolocationCoordinates) => {
        state.CurrentUserLatitude = newValue.latitude;
        state.CurrentUserLongitude = newValue.longitude;
    },
    // Paging
    setPageSize: (state: any, newValue: number) => state.PageSize = newValue,
    setCurrentPageNumber: (state: any, newValue: number) => state.CurrentPageNumber = newValue,
    setTotalSearchResults: (state: any, newValue: number) => state.TotalSearchResults = newValue,
    setTotalPages: (state: any) => state.TotalPages = Math.ceil(state.TotalSearchResults/state.PageSize),
    incrementPage: (state: any) => state.CurrentPageNumber += 1,
    decrementPage: (state: any) => state.CurrentPageNumber -= 1,
    gotoFirstPage: (state: any) => state.CurrentPageNumber = 1,
    gotoLastPage: (state: any) => state.CurrentPageNumber = state.TotalPages,
    // Filtering
    setShowFilterButton: (state: any, newValue: boolean) => state.ShowFilterButton = newValue,
    // Searching
    setIsSearching: (state: any, newValue: boolean) => state.IsSearching = newValue,
    setIsRecentHistorySearch: (state: any, newValue: boolean) => state.IsRecentHistorySearch = newValue,
    setHasSearched: (state: any, newValue: boolean) => state.HasSearched = newValue,
    setShowSearchHistory: (state: any, newValue: boolean) => state.ShowSearchHistory = newValue,
    setSearchText: (state: any, newValue: string) => state.SearchText = newValue,
    setSearchHistoryIndex: (state: any, newValue: string) => state.SearchHistoryIndex = newValue,
    addToSearchHistory: (state: any, newValue: string) => {
        state.SearchText = newValue;
        if (newValue && state.SearchHistory && !state.SearchHistory.includes(newValue)) {
            state.SearchHistory.unshift(newValue);
            state.SearchHistory.splice(state.MaxHistoryLength, state.SearchHistory.length);
        }
    },
    addToSearchHistoryCoords: (state: any, newValue: any) => {
        let myObject = {longitude: newValue.lng(), latitude: newValue.lat()}
        state.SearchHistoryCoords.unshift(myObject);
        state.SearchHistoryCoords.splice(state.MaxHistoryLength, state.SearchHistoryCoords.length);
    },
    // Mobile
    setEmblaScrollToIndex: (state: any, newValue: number) => state.EmblaScrollToIndex = newValue,
    setUsedMyLocation: (state: any, newValue: boolean) => state.UsedMyLocation = newValue,
    setWidgetTitle: (state: any, newValue: string) => state.WidgetTitle = newValue,
    setUserId: (state: any, newValue: number) => state.UserID = newValue,
};